import script from "./ClockAnalog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClockAnalog.vue?vue&type=script&setup=true&lang=js"

import "./ClockAnalog.vue?vue&type=style&index=0&id=4a7b517b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a7b517b"]])

export default __exports__